import React from 'react';
import classNames from 'classnames';
import { Field, useField } from 'formik';

import styles from './GenericPaymentMethod.module.scss';

type GenericPaymentMethodProps = {
  value: string;
  labelContent: React.ReactNode;
  classes?: {
    methodTitle?: string;
    methodContent?: string;
  };
  onClick?: () => void;
  isDisabled?: boolean;
};

const GenericPaymentMethod = ({
  value,
  labelContent,
  classes,
  children,
  onClick,
  isDisabled = false,
}: React.PropsWithChildren<GenericPaymentMethodProps>): JSX.Element => {
  const [{ value: fieldValue }, , { setValue }] = useField('paymentMethod');
  const isChecked = fieldValue === value;

  function onClickContainer(): void {
    if (!isChecked && !isDisabled) {
      setValue(value);
      onClick?.();
    }
  }

  return (
    <div
      onClick={onClickContainer}
      className={classNames(styles.methodRow, {
        [styles.checked]: isChecked,
        [styles.disabled]: isDisabled,
      })}
    >
      <div className={classNames(styles.methodTitle, classes?.methodTitle)}>
        <Field
          type="radio"
          name="paymentMethod"
          value={value}
          id={`method-${value}`}
          className={styles.selectPaymentMethodRadio}
          disabled={isDisabled}
        />
        <label htmlFor={`method-${value}`}>{labelContent}</label>
      </div>
      <div className={classNames(styles.methodContent, classes?.methodContent)}>
        {children}
      </div>
    </div>
  );
};

export default GenericPaymentMethod;
